export default function TermsPage() {
  return (
    <div style={{ padding: "2rem", direction: "rtl" }}>
      <h1>תנאי שימוש</h1>
      <p>ברוכים הבאים ל־matay.today. השימוש באתר כפוף לתנאים הבאים:</p>
      <ul>
        <li>כל התכנים באתר מוצגים למטרות מידע כללי בלבד.</li>
        <li>אין לראות במידע באתר תחליף לייעוץ מקצועי (משפטי, רפואי או אחר).</li>
        <li>השימוש באתר הוא באחריות המשתמש בלבד.</li>
        <li>האתר רשאי לעדכן את התנאים בכל עת ללא הודעה מראש.</li>
      </ul>
      <p>אם אינך מסכים לתנאים – אנא הימנע משימוש באתר.</p>
    </div>
  );
}
